import { NavigateFunction } from "react-router-dom";

const INTERNAL_HOSTS = ["app.onbento.com", "crm.hatchways.io"];

export const getInternalPath = (href: string): string | null => {
  if (!href) return null;
  if (href.startsWith("/")) return href;
  try {
    const url = new URL(href);
    const isInternalHost =
      url.host === window.location.host || INTERNAL_HOSTS.includes(url.host);
    if (!isInternalHost) return null;
    return `${url.pathname}${url.search}${url.hash}`;
  } catch {
    return null;
  }
};

export const navigateBackPath = (pathName: string, position: number = 1) => {
  const pathParts = pathName.split("/");
  for (let i = 0; i < position; i++) {
    pathParts.pop();
  }
  return pathParts.join("/") || "/";
};

export const navigateBack = (
  navigate: NavigateFunction,
  pathName: string,
  position: number = 1,
) => {
  const newPath = navigateBackPath(pathName, position);
  navigate(newPath);
};
